// Pure gate for cs-day-items' "What's new" changelog card. Given the
// revision of the shared changelog document
// (`$text/en-us/@help:app-version-changelog` in global_common) and the
// revision the user last acknowledged (`profile.lastAppChangelog`),
// returns whether the "What's new" card should show.
//
// The revision is deliberately always read from the ENGLISH document, even
// for a user reading the app in another language: `lastAppChangelog` is one
// per-user value that syncs across devices, and per-locale documents have
// unrelated revision lineages, so a localized rev could never agree with it.
// The changelog TEXT the user reads is still served in their language — only
// this identity is pinned. See design-docs/global-common-localization.md.
//
// Pure so the gate is unit-testable without instantiating Angular
// (mocha's ts-node register can't load files that transitively pull in
// @angular/core's ESM exports — same constraint as cs-day-items-update-card.ts
// and the VersionCheckService helpers).
//
// The card surfaces when a NEWER changelog has been published than the
// one the user has already seen. It must NOT show when:
//  - the user has never seen any changelog (first-time user): in that
//    case `lastAppChangelog` is undefined / empty, and showing a "What's
//    new" nudge to someone with no baseline makes no sense.
//  - the changelog document is not available locally yet
//    (`changelogRev` undefined): we have nothing to point the card at,
//    so stay hidden until the doc arrives (a sync grafting the doc in
//    will re-run this gate via the reactive watcher in cs-day-items).
export function shouldShowWhatsNewCard(
  changelogRev: string | undefined,
  lastAppChangelog: string | undefined,
): boolean {
  // if the user has no acknowledged-changelog baseline → first-time
  // user, never show
  if (!lastAppChangelog) {
    return false;
  }
  // if the changelog doc is not known locally yet → nothing to show
  if (!changelogRev) {
    return false;
  }
  // show when a newer changelog has been published than the one the
  // user last saw
  return lastAppChangelog !== changelogRev;
}
